import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Grid, Typography, Chip, Divider
} from '@mui/material';
import { Lead } from '../../types';

interface LeadDetailModalProps {
  lead: Lead | null;
  open: boolean;
  onClose: () => void;
}

const LeadDetailModal: React.FC<LeadDetailModalProps> = ({ lead, open, onClose }) => {
  if (!lead) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{lead.name}</Typography>
        <Chip
          label={lead.stage}
          color="primary"
          size="small"
        />
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">Contact Information</Typography>
            <Typography variant="body1">{lead.email}</Typography>
            <Typography variant="body1">{lead.phone}</Typography>
          </Grid>

          <Grid item xs={12}><Divider /></Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">Source</Typography>
            <Typography variant="body1">{lead.source}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">Priority</Typography>
            <Chip
              label={lead.priority}
              size="small"
              color={lead.priority === 'High' ? 'error' : 'default'}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">Assigned To</Typography>
            <Typography variant="body1">{lead.assignedTo}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" color="primary">Update Stage</Button>
        <Button variant="outlined" color="secondary">Assign Member</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadDetailModal;
